/**
 * Escapes special characters $, (, ), *, +, ., ?, [, \, ], ^, {, |, and }
 * in a string for use in a regular expression.
 */
export const escapeRegExp = (text: string) => {
  return text.replaceAll(/[$()*+.?[\\\]^{|}]/gu, String.raw`\$&`);
};
